import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { asyncScheduler, Subscription, Subject, Observable } from 'rxjs';
import { IProductos } from './../../../private/shared/models/productos';

import { ModalConfirmPage } from '../../../private/shared/components/modal-confirm/modal-confirm.page';
import { PushEjecucionPage } from '../../../private/shared/components/push-ejecucion/push-ejecucion.page';
import { IPromosEcommerce, PedidoActualEntity } from '../../../private/shared/models/productos';
import { IPushEjecucion } from '../../../private/shared/models/push-ejecucion';
import { HowDoesWorkPage } from '../../modals/how-does-work/how-does-work.page';
import { ResetUserPage } from '../../modals/reset-user/reset-user.page';
import { LeavePromoDetailPage } from '../../modals/leave-promo-detail/leave-promo-detail.page';
import { IAnalyticsListContext } from '../../models/Analytics';
import { IRespPreRegister } from '../../models/ApplicationUser';
import { InfoSheetModalOptions } from '../../models/InfoSheetModal.model';
import { ILegacyVersions } from '../../models/Legales';
import { ModalConfirm } from '../../models/modal-confirm.model';

@Injectable({
  providedIn: 'root'
})
export class ModalsService {

  private modalClosed$ = new Subject<{ component: any; data: any }>();

  public getModalClosedEvent(): Observable<{ component: any; data: any }> {
    return this.modalClosed$.asObservable();
  }

  private modalGeneric: HTMLIonModalElement | null = null;
  private modalLegal: HTMLIonModalElement | null = null;
  private modalAggregateCart: HTMLIonModalElement | null = null;
  private dismissAggregateCart: Subscription | null = null;
  private modalPromotion: HTMLIonModalElement | null = null;
  private modalPromoDetail: HTMLIonModalElement | null = null;

  constructor(
    private modalCtrl: ModalController
  ) { }

  public modalDismiss = async () => {
    if (this.modalGeneric) {
      await this.modalGeneric.dismiss(false);
    }
  }

  public modalActives = async () => await this.modalCtrl.getTop() ? true : false;

  public modalDismissActive = async () => {
    const acutalModal = await this.modalCtrl.getTop();
    return await this.modalCtrl.dismiss(null, '', acutalModal?.id);
  }

  public modalConfirm = async (modalConfirm: ModalConfirm) => {
    this.modalGeneric = await this.modalCtrl.create({
      component: ModalConfirmPage,
      componentProps: { ModalConfirm: modalConfirm },
      cssClass: 'modal-confirm',
      backdropDismiss: false,
      showBackdrop: true
    })

    await this.modalGeneric.present()

    const { data } = await this.modalGeneric.onDidDismiss()

    return data

  }

  public async presentModalHowDoesWork(how: { color: string; title: string, content: string[] }): Promise<boolean> {
    this.modalGeneric = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: false,
      component: HowDoesWorkPage,
      componentProps: {
        how
      },
      cssClass: 'modal-how-does-work',
      keyboardClose: true,
      mode: 'ios',
      showBackdrop: true
    });

    await this.modalGeneric.present();

    const { data } = await this.modalGeneric.onDidDismiss();
    return data;

  }

  public async presentModalResetUser(): Promise<boolean> {
    this.modalGeneric = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: false,
      component: ResetUserPage,
      keyboardClose: true,
      mode: 'ios',
      showBackdrop: true
    });

    await this.modalGeneric.present();

    const { data } = await this.modalGeneric.onDidDismiss();
    return data;
  }

  public async presentModalCancelPromo(component: any): Promise<boolean> {
    this.modalGeneric = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: false,
      component,
      cssClass: 'modal-leave-promo-detail',
      keyboardClose: true,
      mode: 'ios',
      showBackdrop: true
    });

    await this.modalGeneric.present();

    const { data } = await this.modalGeneric.onDidDismiss();
    return data;
  }

  public async modalEjecucionPush(params: IPushEjecucion | any) {
    this.modalGeneric = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: false,
      component: PushEjecucionPage,
      componentProps: { Params: params },
      cssClass: 'modal-ejecucion-push',
      keyboardClose: true,
      mode: 'ios',
      showBackdrop: true
    })

    await this.modalGeneric.present()

    const { data } = await this.modalGeneric.onDidDismiss()

    return data;

  }

  public modalEjecucionResultPush = async (component: any, title: string, body: string): Promise<boolean> => {
    this.modalGeneric = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: false,
      component,
      componentProps: { title, body },
      cssClass: 'modal-ejecucion-result-push',
      keyboardClose: true,
      mode: 'ios',
      showBackdrop: true,
    });

    await this.modalGeneric.present();

    const { data } = await this.modalGeneric.onWillDismiss();
    return data;
  }

  public modalSuggestedOrderList = async (component: any): Promise<boolean> => {
    this.modalGeneric = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: false,
      component,
      cssClass: 'ion-modal-overlayPage',
      keyboardClose: true,
      mode: 'ios',
      showBackdrop: true
    });

    await this.modalGeneric.present();

    const { data } = await this.modalGeneric.onDidDismiss();
    return data;
  }

  public modalSpamCart = async (component: any): Promise<boolean> => {
    this.modalGeneric = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: false,
      component,
      cssClass: 'ion-modal-overlayPage',
      keyboardClose: true,
      mode: 'ios',
      showBackdrop: true
    });

    await this.modalGeneric.present();

    const { data } = await this.modalGeneric.onWillDismiss();
    return data;
  }

  public openModalLegalChange = async (component: any, legales: ILegacyVersions[]) => {
    this.modalLegal = await this.modalCtrl.create({
      component,
      backdropDismiss: false,
      showBackdrop: true,
      cssClass: 'modal-legal-change',
      componentProps: {
        legales: legales.map(x => ({ ...x, Cambio: false })),
      }
    })

    await this.modalLegal.present();
    const { data } = await this.modalLegal.onWillDismiss();
    return data;
  }

  public modalRecuperacion = async (component: any, telefono: string): Promise<boolean> => {
    this.modalGeneric = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: false,
      component,
      componentProps: { telefono },
      cssClass: 'modal-change-pass',
      keyboardClose: true,
      mode: 'ios',
      showBackdrop: true,
    });

    await this.modalGeneric.present();

    const { data } = await this.modalGeneric.onDidDismiss();
    return data;
  }

  public modalGames = async (component: any): Promise<boolean> => {
    this.modalGeneric = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: false,
      component,
      cssClass: 'modal-lifeless',
      keyboardClose: true,
      mode: 'ios',
      showBackdrop: true,
    });

    await this.modalGeneric.present();

    const { data } = await this.modalGeneric.onDidDismiss();
    return data;
  }

  public modalNewSectionGames = async (component: any): Promise<boolean> => {
    this.modalGeneric = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: false,
      component,
      cssClass: 'modal-new-section-games',
      keyboardClose: true,
      mode: 'ios',
      showBackdrop: true,
    });

    await this.modalGeneric.present();

    const { data } = await this.modalGeneric.onWillDismiss();
    return data;
  }

  public openModalPromotion = async (component: any, idPopUp: number): Promise<1 | 2> => {
    this.modalPromotion = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: false,
      component,
      componentProps: { idPopUp },
      cssClass: 'modal-new-section-games',
      keyboardClose: true,
      mode: 'ios',
      showBackdrop: true,
    });

    await this.modalPromotion.present();
    const { data } = await this.modalPromotion.onDidDismiss();
    return data;
  }

  public modalConfirmCancel = async (component: any): Promise<boolean> => {
    this.modalGeneric = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: false,
      component,
      cssClass: 'modal-confirm-cancel',
      keyboardClose: true,
      mode: 'ios',
      showBackdrop: true,
    });

    await this.modalGeneric.present();

    const { data } = await this.modalGeneric.onWillDismiss();
    return data;
  }

  public modalDetailPromo = async (
    component: any,
    promo: IPromosEcommerce,
    analyticsContext?: IAnalyticsListContext
  ): Promise<boolean> => {
    this.modalPromoDetail = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: false,
      component,
      componentProps: { promo, analyticsContext },
      cssClass: 'modal-promo-detail',
      keyboardClose: true,
      mode: 'ios',
      showBackdrop: true,
      canDismiss: async (data?: any, role?: string) => {
        if (data) return true;
        const tiposConConfirmacion = ['DINAMICO', 'ESCALERA', 'BONIFICACION'];
        if (tiposConConfirmacion.includes(promo.TipoPromocion)) {
          return await this.presentModalCancelPromo(LeavePromoDetailPage);
        }
        return true;
      },
    });

    await this.modalPromoDetail.present();

    const { data } = await this.modalPromoDetail.onWillDismiss();
    this.modalClosed$.next({ component, data });
    return data;
  }

  public modalAddCart = async (component: any, addCart: IProductos | IPromosEcommerce | Array<IProductos>) => {
    this.dismissModalAggregateCart();
    this.modalAggregateCart = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: false,
      component,
      componentProps: { addCart: new Array().concat(addCart) },
      cssClass: 'modal-add-cart',
      keyboardClose: true,
      mode: 'md',
      showBackdrop: false,
    });

    await this.modalAggregateCart.present();
    this.dismissAggregateCart = asyncScheduler.schedule(this.dismissModalAggregateCart, 3000);
    return;
  }

  private dismissModalAggregateCart = async () => {
    if (this.modalAggregateCart) { await this.modalAggregateCart.dismiss(); }
    if (this.dismissAggregateCart) { this.dismissAggregateCart.unsubscribe(); }
  }

  public modalPurchaseProgress = async (component: any): Promise<boolean> => {
    this.modalGeneric = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: false,
      component,
      cssClass: 'modal-purchase-progress',
      keyboardClose: true,
      mode: 'ios',
      showBackdrop: true,
    });

    await this.modalGeneric.present();

    const { data } = await this.modalGeneric.onWillDismiss();
    return data;
  }

  public modalOrderProgress = async (component: any, order: PedidoActualEntity): Promise<boolean> => {
    if (await this.modalActives()) { await this.modalDismissActive(); }
    this.modalGeneric = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: false,
      component,
      componentProps: { order },
      cssClass: 'modal-order-progress',
      keyboardClose: true,
      mode: 'ios',
      showBackdrop: true,
    });

    await this.modalGeneric.present();

    const { data } = await this.modalGeneric.onWillDismiss();
    return data;
  }

  public modalContinueReset = async (component: any): Promise<boolean> => {
    this.modalGeneric = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: false,
      component,
      cssClass: 'modal-order-progress',
      keyboardClose: true,
      mode: 'ios',
      showBackdrop: true,
    });

    await this.modalGeneric.present();

    const { data } = await this.modalGeneric.onWillDismiss();
    return data;
  }

  public modalUserTicket = async (component: any): Promise<boolean> => {
    this.modalGeneric = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: false,
      component,
      cssClass: 'modal-user-ticket',
      keyboardClose: true,
      mode: 'ios',
      showBackdrop: true,
    });

    await this.modalGeneric.present();

    const { data } = await this.modalGeneric.onWillDismiss();
    return data;
  }

  public modalSuccessReset = async (component: any): Promise<boolean> => {
    this.modalGeneric = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: false,
      component,
      cssClass: 'modal-success-reset',
      keyboardClose: true,
      mode: 'ios',
      showBackdrop: true,
    });

    await this.modalGeneric.present();

    const { data } = await this.modalGeneric.onWillDismiss();
    return data;
  }

  public modalTimeOutEdit = async (component: any): Promise<boolean> => {
    this.modalGeneric = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: false,
      component,
      cssClass: 'modal-timeout-edit',
      keyboardClose: true,
      mode: 'ios',
      showBackdrop: true,
    });

    await this.modalGeneric.present();

    const { data } = await this.modalGeneric.onWillDismiss();
    return data;
  }

  public modalSpamMoreProducts = async (component: any): Promise<boolean> => {
    this.modalGeneric = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: false,
      component,
      cssClass: 'modal-more-products',
      keyboardClose: true,
      mode: 'ios',
      showBackdrop: true,
    });

    await this.modalGeneric.present();

    const { data } = await this.modalGeneric.onWillDismiss();
    return data;
  }

  public modalDataRegisters = async (component: any, componentProps: IRespPreRegister): Promise<boolean> => {
    this.modalGeneric = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: false,
      component,
      componentProps: { componentProps },
      cssClass: 'modal-data-register',
      keyboardClose: true,
      mode: 'ios',
      showBackdrop: true,
    });

    await this.modalGeneric.present();

    const { data } = await this.modalGeneric.onDidDismiss<boolean>();

    return data ?? false;

  }

  public modalPhoneRegisters = async (component: any): Promise<boolean> => {
    this.modalGeneric = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: false,
      component,
      cssClass: 'modal-data-register',
      keyboardClose: true,
      mode: 'ios',
      showBackdrop: true,
    });

    await this.modalGeneric.present();

    const { data } = await this.modalGeneric.onDidDismiss<boolean>();

    return data ?? false;

  }

  public modalLimitCounters = async (component: any, componentProps: { title: string; description: string; smsCountDown: { countdown: number; time: string; }; }): Promise<boolean> => {
    this.modalGeneric = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: false,
      component,
      componentProps: { componentProps },
      cssClass: 'modal-data-register',
      keyboardClose: true,
      mode: 'ios',
      showBackdrop: true,
    });

    await this.modalGeneric.present();

    const { data } = await this.modalGeneric.onDidDismiss<boolean>();

    return data ?? false;

  }

  public presentModalInfoSheet = async (component: any, config: InfoSheetModalOptions): Promise<any> => {
    this.modalGeneric = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: true,
      component,
      componentProps: { config },
      cssClass: 'modal-info-sheet',
      keyboardClose: true,
      mode: 'ios',
      showBackdrop: true,
    });

    await this.modalGeneric.present();

    const { data } = await this.modalGeneric.onDidDismiss();
    return data ?? false;
  }

  public presentModalPromoSummary = async (component: any, componentProps: { promo: IPromosEcommerce; productosPromocion: IProductos[]; isResume?: boolean, quantity?: number }): Promise<boolean | number> => {
    this.modalGeneric = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: true,
      component,
      componentProps,
      cssClass: 'modal-promo-summary',
      keyboardClose: true,
      mode: 'ios',
      showBackdrop: true,
    });

    await this.modalGeneric.present();

    const { data } = await this.modalGeneric.onDidDismiss();
    return data ?? false;
  }

  public presentModalPromoInfo = async (component: any, componentProps: { promo: IPromosEcommerce }): Promise<boolean> => {
    this.modalGeneric = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: true,
      component,
      componentProps,
      cssClass: 'modal-promo-summary',
      keyboardClose: true,
      mode: 'ios',
      showBackdrop: true,
    });

    await this.modalGeneric.present();

    const { data } = await this.modalGeneric.onDidDismiss();
    return data ?? false;
  }

  public presentModalReward = async (component: any): Promise<number> => {
    this.modalGeneric = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: true,
      component,
      cssClass: 'modal-reward',
      keyboardClose: true,
      mode: 'ios',
      showBackdrop: true,
    });

    await this.modalGeneric.present();

    const { data } = await this.modalGeneric.onDidDismiss();
    return data ?? 0;
  }

  public presentModalMaxDiscountsLimit = async (component: any): Promise<boolean> => {
    this.modalGeneric = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: false,
      component,
      cssClass: 'modal-max-discounts-limit',
      keyboardClose: false,
      mode: 'ios',
      showBackdrop: true,
    });

    await this.modalGeneric.present();

    const { data } = await this.modalGeneric.onDidDismiss();
    return data ?? false;
  }

  public presentModalCartWithoutStock = async (component: any, componentProps: { modalData: { title: string; content: string; button: string; } }): Promise<boolean> => {
    this.modalGeneric = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: false,
      component,
      componentProps,
      cssClass: 'modal-cart-without-stock',
      keyboardClose: false,
      mode: 'ios',
      showBackdrop: true,
    });

    await this.modalGeneric.present();

    const { data } = await this.modalGeneric.onDidDismiss();
    return data ?? false;
  }

  public presentModalDeleteProductCart = async (component: any, componentProps?: any): Promise<boolean> => {
    this.modalGeneric = await this.modalCtrl.create({
      animated: true,
      backdropDismiss: false,
      component,
      componentProps,
      cssClass: 'modal-delete-product-cart',
      keyboardClose: false,
      mode: 'ios',
      showBackdrop: true,
    });

    await this.modalGeneric.present();

    const { data } = await this.modalGeneric.onWillDismiss();
    return data ?? false;
  }

}
